import { useTranslation } from 'react-i18next';
import { WHATSAPP_BASE } from '@/constants';

export default function FinalCTA() {
  const { t } = useTranslation();
  const whatsappHref = `${WHATSAPP_BASE}?text=${encodeURIComponent(t('whatsapp.message'))}`;

  return (
    <section className="relative overflow-hidden bg-foreground-950 py-20 md:py-28">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Luxury%20modern%20villa%20at%20dusk%20with%20an%20integrated%20premium%20enclosed%20garage%20and%20warm%20gold%20accent%20lighting%2C%20anthracite%20dark%20facade%20with%20natural%20wood%20details%2C%20minimalist%20luxury%20aesthetic%2C%20wide%20composition%2C%20high%20detail%2C%20professional%20editorial%20photography&width=1600&height=800&seq=vg-final-01&orientation=landscape')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/85 to-foreground-950"></div>

      <div className="relative z-10 mx-auto max-w-3xl px-4 text-center md:px-6">
        <span className="reveal mb-5 inline-block h-px w-12 bg-primary-500"></span>
        <h2 className="reveal reveal-delay-1 font-heading text-3xl leading-tight text-background-50 md:text-4xl lg:text-5xl">
          {t('final.title')}
        </h2>

        <div className="reveal reveal-delay-2 mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href="#iletisim"
            className="whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400"
          >
            {t('final.cta1')}
          </a>
          <a
            href={whatsappHref}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="whitespace-nowrap rounded-md border border-primary-500/50 px-8 py-3.5 text-sm font-semibold text-primary-400 transition-colors hover:bg-primary-500/10"
          >
            {t('final.cta2')}
          </a>
        </div>
      </div>
    </section>
  );
}